export const Attachment = {
  baseStyle: {
    container: {
      width: "100%",
    },
    fileInfoContainer: {
      background: "none",
      border: "none",
      flexDirection: "row",
    },
    fileInfo: {
      alignItems: "center",
      py: "0.875rem",
    },
  },
}
